import { Brand } from "effect";

export type UserId = string & Brand.Brand<"UserId">;
export const UserId = Brand.nominal<UserId>();

export type SessionId = string & Brand.Brand<"SessionId">;
export const SessionId = Brand.nominal<SessionId>();

export type ExerciseId = string & Brand.Brand<"ExerciseId">;
export const ExerciseId = Brand.nominal<ExerciseId>();

export type WorkoutId = string & Brand.Brand<"WorkoutId">;
export const WorkoutId = Brand.nominal<WorkoutId>();

export type RemoteCommandId = string & Brand.Brand<"RemoteCommandId">;
export const RemoteCommandId = Brand.nominal<RemoteCommandId>();

export const toExerciseId: (id: string) => ExerciseId = ExerciseId;
export const toWorkoutId: (id: string) => WorkoutId = WorkoutId;
export const toSessionId: (id: string) => SessionId = SessionId;
